// Rover Spectator Card
// Purpose: Defines the Rover Spectator Card module and the local helpers/components used in this file.
// Scope: Keeps behavior unchanged while isolating this concern into a clear, single-responsibility unit.
import SpectateVideo from '../../../components/SpectateVideo/index.jsx';

export default function RoverSpectatorCard({ rover }) {
  return (
    <article className="min-h-64 rounded-sm bg-zinc-900 p-0 sm:min-h-72">
      <div className="min-h-0 overflow-hidden rounded-sm bg-black/20">
        <SpectateVideo
          roverId={rover.id}
          label={rover.name}
          needsHelp={Boolean(rover.needsHelp)}
        />
      </div>
    </article>
  );
}
